export const FETCH_ALL = 'FETCH_ALL';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const LIKE = 'FETCH_ALL';
export const CREATE = 'CREATE';

export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
